import { baseList, imageList } from '@components/atoms/Icon/svg';

interface Captcha {
  imageData: HTMLImageElement;
  width: number;
  height: number;
  imageUrl: string;
}

/** 이미지 파일화 */
const setImageFile = (imageUrl: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      resolve({
        imageData: img,
        width: img.width,
        height: img.height,
        imageUrl,
      });
    };
    img.onerror = reject;
  });
};

/** 이미지 가져오기 */
const setImage = async (fileUrl: string): Promise<Captcha> => {
  return <Captcha>await setImageFile(fileUrl);
};

/** 이미지 데이터 생성 (낱개) */
export const getImageData = async (
  { fileUrl, name, alt }: { fileUrl: string; name: string; alt: string },
  imageHeight: number,
  DPR: number,
) => {
  const result = await setImage(fileUrl);
  const ratio = result.height / imageHeight;
  const imageWidth = Math.floor(result.width / ratio);

  return {
    ...result,
    name,
    alt,
    height: imageHeight * DPR,
    width: imageWidth * DPR,
  };
};

/** 이미지 사이즈 포함해서 가져오기 */
export const getImageWithSize = async (imageHeight: number, DPR: number) => {
  const basePromises = baseList.map(item => getImageData(item, imageHeight, DPR));
  const imagePromises = imageList.map(item => getImageData(item, imageHeight, DPR));
  const baseData = await Promise.all(basePromises);
  const imageData = await Promise.all(imagePromises);
  const allImageData = [...baseData, ...imageData];

  return {
    base: baseData.sort(() => Math.random() - 0.5),
    image: imageData.sort((a, b) => a.width - b.width),
    allImage: allImageData,
  };
};

/** 배열 요소를 무작위로 섞고 그중에서 6개의 이미지만 가져오기 */
export const getRandomImages = async (imageHeight: number, DPR: number) => {
  const { allImage } = await getImageWithSize(imageHeight, DPR);

  if (allImage.length < 6) {
    throw new Error('이미지의 갯수가 부족합니다');
  }

  const shuffledArray = allImage.sort(() => Math.random() - 0.5);
  return { randomImages: shuffledArray.slice(0, 6) };
};
